import { createEmptyContext } from '../../../../../utils/create-empty-context';
import { DefaultDropdownOptionTemplate } from '../option-templates/default';
/**
 * Dropdown context will wrap all children components and be available as merged props
 */
export const DropdownContextInstance = createEmptyContext();
/**
 * Utility method to create `DropdownContext` object from `DropdownProps`.
 */
export function mapDropdownContext(props, state, events, defaultComponentId) {
    const selectedOption = props.options.find(o => o.value === props.value);
    const optionTemplate = props.optionTemplate || DefaultDropdownOptionTemplate;
    const optionPreviewTemplate = props.optionPreviewTemplate || optionTemplate;
    const dropdownId = props.id || `v-dropdown-${defaultComponentId}`;
    const showSearch = props.enableSearch !== false && state.isDropdownExpanded;
    const { modal } = props;
    const hasError = !!(modal === null || modal === void 0 ? void 0 : modal.errorTitle) || !!(modal === null || modal === void 0 ? void 0 : modal.errorMessage) || !!(modal === null || modal === void 0 ? void 0 : modal.errorIconName);
    const showModalErrorMessage = !!(modal === null || modal === void 0 ? void 0 : modal.displayAsModalOnMobile) && (hasError || (!!state.filteredOptions && !state.filteredOptions.length));
    return Object.assign(Object.assign(Object.assign(Object.assign({}, props), state), events), { dropdownId, optionGroups: props.optionGroups || [], displayAsModalOnMobile: !!(modal === null || modal === void 0 ? void 0 : modal.displayAsModalOnMobile), optionTemplate,
        optionPreviewTemplate,
        selectedOption,
        showSearch,
        showModalErrorMessage });
}
//# sourceMappingURL=context.js.map